<template>
    <div>
        <div class="d-flex my-1">
            <label class="mt-1 mx-1" style="width: 120px;">Browse</label>
            <div class="mx-1">
                <div class="mb-3 pointer">
                    <input class="form-control" type="file" id="fileElem" multiple @change="handleFileSelect">
                </div>
            </div>
        </div>

        <div class="d-flex my-1">
            <label class="mt-1 mx-1" for="imageSearchInput" style="width: 120px;">Image Search</label>

            <input type="text" class="mx-1 form-control" id="imageSearchInput" v-model="imageSearch"
                   style="width: auto !important;"
                   placeholder="search" v-on:keyup.enter="onSearchClick">

            <button class="btn btn-primary m-0" @click="onSearchClick" style="width: 137px;">search</button>
        </div>

        <div v-if="unsplashImages.length > 0" class="w-100 mt-2 d-flex justify-content-center flex-wrap">
            <div v-for="unsplashImage in unsplashImages" class="mt-1 mx-2 pointer"
                 @click="onImageSelected(unsplashImage)"
                 :class="unsplashImage === selectedUnspashImage ? 'border-selected-image border-secondary' : ''">
                <img :src="getImageUrl(unsplashImage)" width="300">
                <div class="text-center" style="width: 300px;">
                    <span class="badge text-bg-light">
                        photo by <a :href="getAuthorLink(unsplashImage)" class="text-primary"
                                    target="_blank">{{ getImageAuthor(unsplashImage) }}</a> on <a
                            href="https://unsplash.com/?utm_source=Webase&utm_medium=referral"
                            class="text-primary" target="_blank">Unsplash</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UIUtil from "../utils/UIUtil";
import ImageService from "../services/ImageService";
import RestService from "../services/RestService";

export default {
    name: 'ImageEditor',
    props: ['document', 'field', 'table'],
    data() {
        return {
            model: webase.model,
            uiUtil: new UIUtil(),
            highlightEnabled: false,
            imageSearch: '',
            unsplashImages: [],
            imageService: new ImageService(),
            selectedFile: null,
            selectedUnspashImage: null
        }
    },
    computed: {
        selectFileLabel() {
            return this.selectedFile ? this.selectedFile.name : 'browse'
        }
    },
    mounted() {
    },
    methods: {
        onSearchClick() {

            let service = new RestService()
            let url = webase.utils.app.getBaseUrl() + '/api/v1/unsplash-search/?query=' + this.imageSearch + '&t=' + Date.now()
            service.executeGet(url).then((json) => {
                this.unsplashImages = json.results

                // let properties = {
                //     searchString: this.imageSearch,
                //     total: json.total,
                //     total_pages: json.total_pages
                // }
                //
                // console.log('Image search')
                // console.log(properties)
                //
                // webase.events.track('UnsplashSearch', properties);
            }).catch((error) => {
                console.log('UnsplashSearch error')
                console.log(error)
            })

        },
        handleFileSelect(event) {
            let files = event.target.files

            if (files && files[0]) {
                this.selectedFile = files[0]
                this.uploadFile()
            }
        },
        saveUnsplashImage() {
            this.model.loading = true

            let request = {
                image: {
                    name: this.imageSearch,
                    source: 'Unsplash',
                    imageable_type: 'Field',
                    imageable_id: this.field.index,
                    metadata: this.selectedUnspashImage
                }
            }

            this.imageService.create(request).then((image) => {
                this.model.loading = false
                this.onFinished(image)
                this.triggerDownload()
            }).catch((error) => {
                console.log('Unsplash image save error')
                console.log(error)
                this.model.loading = false
                alert('Image upload error, ' + error)
            })
        },
        uploadFile() {
            console.log('ImageEditor.uploadFile')
            console.log(this.selectedFile)
            this.model.loading = true
            let imageableType = 'Field'
            let imageableId = this.field.id

            this.imageService.uploadImage(imageableType, imageableId, this.selectedFile).then((image) => {
                this.model.loading = false
                this.onFinished(image)
            }).catch((error) => {
                console.log('Image upload error')
                console.log(error)
                this.model.loading = false
                alert('Image upload error, ' + error)
            })
        },
        onFinished(image) {
            this.document[this.field.index] = image
        },
        getImageUrl(image) {
            return image.urls.small
        },
        getImageAuthor(image) {
            return image.user.name
        },
        getAuthorLink(image) {
            return image.user.links.html + '?utm_source=Webase&utm_medium=referral'
        },
        onImageSelected(unsplashImage) {
            console.log('onImageSelected')
            console.log(unsplashImage)
            this.selectedUnspashImage = unsplashImage
            this.saveUnsplashImage()
        },
        triggerDownload() {
            let service = new RestService()
            let url = webase.utils.app.getBaseUrl() + '/api/v1/unsplash-download/' + this.selectedUnspashImage.id + '?t=' + Date.now()
            service.executeGet(url)
        }
    }
}
</script>

<style>

</style>
